import fetch from '../utils/fetch'
export function getPcItemsList (query) {
  return fetch({
    url: '/goods/items',
    method: 'get',
    params: query
  })
}

